// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 572) return "cui.508ca0b4ba7aad5fc072.js";
	// return url for filenames based on template
	return "" + ({"96":"vendors","593":"framework","644":"react","678":"mui","895":"infra"}[chunkId] || chunkId) + "." + {"47":"8962d9b1ce00c3f2c9b7","96":"a569fb0b3725ad0214fc","593":"749c2d53f5112de21f4e","644":"20b37c8b493d0d95d367","678":"ff2d54959592643174f4","766":"bf8a3f0a98c08e7b9521","895":"09d6afd429aea2376fb6"}[chunkId] + ".chunk.js";
};